export interface IUserContext {
  email: string;
  firstName: string;
  lastName: string;
  fullName: string;
  language: string;
}

export type UserContextType = {
  currentUser: IUserContext;
  saveCurrentUser: (userContext: IUserContext) => void;
};

export const DefaultUserContextType: UserContextType = {
  currentUser: {
    language: "en",
    email: "",
    firstName: "",
    lastName: "",
    fullName: ""
  },
  saveCurrentUser: (_: IUserContext) => {}
};
